export const routes = {
  HOME: "/",
};
